import React, { useEffect, useState } from "react";
import Layout2 from "../../components/global/layout2";
import environment from "../../environment";
import ApiClient from "../../methods/api/apiClient";
import loader from "../../methods/loader";
import methodModel from "../../methods/methods";
import moment from "moment";
import DateRangePicker from "../../components/common/DateRangePicker";
import datepipeModel from "../../models/datepipemodel";
import axios from "axios";
import { TbArrowLeft, TbArrowsLeft } from "react-icons/tb";
import SelectDropdown from "../../components/common/SelectDropdown";
import Select from 'react-select';
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";
// For export functionality
// import { CSVLink } from "react-csv";

export default function LoadsListing() {
  const [filters, setfilters] = useState({ board_id: environment.uspsId, startDate: '', endDate: '', page: 1, count: 1000,origin_location_state:methodModel.getPrams("state"),origin_location_city:methodModel.getPrams("city")||''})
  const [loadsData, setLoadsData] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
const history=useHistory()
const location=useLocation()
  const updateQueryParam = (key, value) => {
    // Get current query params
    const searchParams = new URLSearchParams(location.search);

    // Set or update the parameter
    searchParams.set(key, value);

    // Push new URL with updated query
    history.push({
      pathname: location.pathname,
      search: searchParams.toString()
    });
  };
  // Fetch loads data
  const getLoads = (p = {},loaderData=true) => {
    if(loaderData){
    loader(true);
    }
    ApiClient.get(`loads-list-by-origin`, {
      board_id: environment.uspsId,
      ...filters, ...p
    }).then((res) => {
      if (res?.data) {
        setLoadsData(res?.data);
      }
      if(loaderData){
      loader(false);
      }
    });
  };

  useEffect(() => {
    getLoads();
  }, []);

  // Sorting function
  const sorting = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });

    const sortedData = [...loadsData].sort((a, b) => {
      if (a[key] < b[key]) return direction === "asc" ? -1 : 1;
      if (a[key] > b[key]) return direction === "asc" ? 1 : -1;
      return 0;
    });
    setLoadsData(sortedData);
  };

  // Prepare CSV export data
  const csvData = loadsData.map((item) => ({
    "Load ID": item.load_id,
    "Customer": item.customer_name,
    "Distance (Mi)": item.total_distance,
    "Origin City": item.origin_location_city,
    "Origin State": item.origin_location_state,
    "Destination": item.destination_address,
    "Expiration Date": moment(item.expiration_date).format("DD-MM-YYYY h:mm A"),
    "Status": item.status,
  }));
  const onRangeChange = (e) => {
    let f = {
      startDate: datepipeModel.datetostring(e.startDate),
      endDate: datepipeModel.datetostring(e.endDate),
    };
    
    if (
      e.startDate == e.endDate
    ) {
      setfilters({ ...filters, ...f });
            // getLoads({ ...f },false);
    } else {
      setfilters({ ...filters, ...f });
      getLoads({ ...f });
    }
  };


  const exportfun = async () => {
    loader(true)
    const token = await localStorage.getItem("token");
    let filter = {
      ...filters,
    };
    const req = await axios({
      method: "get",
      url: `${environment.api}export/loads-list-by-origin`,
      responseType: "blob",
      params: { ...filters},
      body: { token: token },
    });
    let blob = new Blob([req.data], {
      type: req.headers["content-type"],
    });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = `LoadListing.xlsx`;
    link.click();
    loader(false)
  };

    const [expandedRow, setExpandedRow] = useState(-1);
    const toggle = (index) => {
      if (expandedRow === index) {
        setExpandedRow(-1);
      } else {
        setExpandedRow(index);
      }
    };
    const pathname = window.location.pathname;
    useEffect(() => {
      setExpandedRow(-1);
    }, [pathname]);
      const ConvertStringToAbbrivate = (str) => {
    let key = str?.includes(" ");
    if (key) {
      let extractletter = str
        ?.split(" ")
        ?.map((word) => methodModel.capitalizeFirstLetter(word[0]));
      return extractletter?.join("");
    } else {
      return str;
    }
  };

  const [StateList,setStateList]=useState([]);
  const GetStateList=()=>{
ApiClient.get(`statistics/loads-state?board_id=${environment.uspsId}`).then(res=>{
  if(res.success){
setStateList(res?.data?.map((_itm)=>({id:_itm?.name,value:_itm?.name,label:_itm?.name,name:_itm?.name})))
  }
})
  }

  const [CityList,setCityList]=useState([]);
  const GetCityList=(p={})=>{
    let filter={board_id:environment.uspsId,state:filters.origin_location_state,...p}
    ApiClient.get(`statistics/loads-city`,filter).then(res=>{
      if(res.success){
        setCityList(res?.data?.map((_itm)=>({id:_itm?.city,value:_itm?.city,label:_itm?.city,name:_itm?.city})))
      }
    })
  }
  useEffect(()=>{
GetStateList()
GetCityList()
  },[])
  return (
    <Layout2 title={`Loads By ${methodModel.getPrams('tab')||'State'}`}>
      <div className="m-5">
        <div className="d-flex justify-content-between mb-3 align-items-center">
          <button
            className="d-flex gap-1 align-items-center btn btn-secondary"
            onClick={() => history.push('/statistics')}
          >
            <TbArrowLeft /> Back
          </button>

          <div className="d-flex align-items-end">

                      <div className="multiselect-custom set-inputs new-drop-width " title="Select State">
                        <label style={{}} className="text-semibold">Select State</label>
                         <div style={{ width: "100px",marginRight:'5px' }}>
  <Select
    className="basic-single"
    classNamePrefix="select"
    placeholder="Select State"
    isClearable={false}
    value={{
      value: filters.origin_location_state,
      label: filters.origin_location_state
    }}
    onChange={e => {
      updateQueryParam('state',e?.value)
      GetCityList({ state: e?.value });
      getLoads({ origin_location_state: e?.value, origin_location_city: "" });
      setfilters(prev => ({
        ...prev,
        origin_location_state: e?.value,
        origin_location_city: ""
      }));
    }}
    options={StateList}
  />
</div>

                  </div>

                     <div className="multiselect-custom set-inputs new-drop-width mx-3" title="Select City">
                      <label style={{}} className="text-semibold">Select City</label>
                      <div style={{ width: "100px",marginRight:'5px' }}>
                       <Select
        className="basic-single"
        classNamePrefix="select"
        isClearable={false}
        value={{value:filters?.origin_location_city,label:filters?.origin_location_city}}
        onChange={e=>{
          updateQueryParam('city',e?.value)
                        getLoads({origin_location_city:e?.value})
                      setfilters(prev=>({...prev,origin_location_city:e?.value}));
                    }}
        placeholder="Select City"
        name="color"
        options={CityList}
      />
      </div>
                  </div>
            <DateRangePicker
              value={{
                startDate: filters.startDate,
                endDate: filters.endDate,
              }}
              onChange={(e) => onRangeChange(e)}
              fullWidth={false}
            />
            <div style={{marginLeft:'3px'}}>
            <button className="ml-3 ml-3 btn btn-primary" onClick={() => exportfun()}>
              Export
            </button>
            </div>
          </div>
        </div>
        <div className="table-responsive table_section mt-4 new-table">


          <table className="table">
            <thead className="table_head">
              <tr className="heading_row">
                <th className="table_data pointer" onClick={() => sorting("expiration_date")}>
                  Time 
                </th>
                <th className="table_data pointer" onClick={() => sorting("load_id")}>
                  Load ID
                </th>
                <th className="table_data pointer" onClick={() => sorting("total_distance")}>
                  Distance (Mi)
                </th>
                <th className="table_data">Origin</th>
                <th className="table_data">Destination</th>

                <th className="table_data">Stops</th>

                <th className="table_data pointer" onClick={() => sorting("status")}>
                  Status
                </th>
              </tr>
            </thead>
            <tbody>
              {loadsData && loadsData.length > 0 ? (
                loadsData.map((itm,i) => (
                  <>
                  <tr key={itm._id} className="data_row bg-white">
                    <td className="table_dats">
                      {moment(itm.expiration_date).fromNow()}
                    </td>
                    <td className="table_dats">{itm.load_id || itm.lane_id || "--"}</td>
                    <td className="table_dats">{itm.total_distance}</td>
                    <td className="table_dats">
                      {itm.origin_address}
                    </td>
                    <td className="table_dats">{itm.destination_address}</td>
                       <td className="table_dats">
                              <div
                                className="stops-down-arrow"
                                onClick={() => toggle(i)}
                              >
                                All Stops
                                <i class="fas fa-arrow-circle-down ms-2"></i>
                              </div>
                             </td>
                    <td className="table_dats text-capitalize">{itm.status}</td>
                  </tr>
                                 <React.Fragment key={i}>
                                              {expandedRow === i && (
                                             <tr>
                              <td colSpan="16" className="bg-white">
                                <div className="stops-inn">
                                  <div className="table_dats">

                                    <table className="table">
                                      <thead>
                                        <th>Stop No.</th>
                                        {itm?.stops?.find((item, index) => item?.location_id) ? <th>Location Id</th> : <></>}

                                        <th>Address</th>
                                      </thead>
                                      <tbody>
                                        {itm?.stops.length ? itm?.stops?.map((item, index) => {
                                          return (
                                            <tr>
                                              <td>{index + 1}</td>
                                              {item?.location_id ? <td>{item?.location_id}</td> : <></>}
                                              <td>{item?.address}</td>
                                            </tr>
                                          );
                                        }) : <tr>
                                          <td colspan="3"><span className="text-center mx-auto d-block py-4">No Data</span></td></tr>}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </td>
                            </tr>
                                              )}
                                            </React.Fragment>
                  </>
                ))
              ) : (
                <tr>
                  <td colSpan={6} className="text-center">
                    No loads found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </Layout2>
  );
}
